import { required, requiredIf } from 'vuelidate/lib/validators';
import { considerations } from '@/app/utils/toolkit/business-rules/inv-strat/otherAssetConsideration';

const newOtherAsset = {
  name: '',
  considerations: [],
  otherConsideration: '',
  collectable: 'no',
};

export default {
  name: 'inv-strat-other-assets-dialog',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    otherAssets: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    isAdd: false,
    considerations: [...considerations],
    newAsset: { ...newOtherAsset },
  }),
  methods: {
    dismiss() {
      this.$emit('close');
    },
    resetOtherText() {
      if (!this.newAsset.considerations.includes(3)) this.newAsset.otherConsideration = '';
    },
    resetNewAsset() {
      this.newAsset = { ...newOtherAsset };
      this.considerations.forEach((consideration) => {
        consideration.consideration.forEach((value) => {
          if (Object.prototype.hasOwnProperty.call(value, 'input')) {
            value.input = 0;
          }
        });
      });
    },
    handleAddAsset() {
      this.isAdd = false;
      // eslint-disable-next-line max-len
      this.newAsset.considerations = this.newAsset.considerations.map(pos => considerations[pos].displayValue());
      this.$emit('addOtherAsset', this.newAsset);
      this.resetNewAsset();
    },
    handleDeleteAsset(pos) {
      this.$emit('deleteOtherAsset', pos);
    },
  },
  validations: {
    otherAssets: {
      required,
    },
    newAsset: {
      otherConsideration: {
        required: requiredIf(function otherRequired() {
          return this.newAsset.considerations.includes(3);
        }),
      },
      name: {
        required,
      },
    },
  },
};
